export const GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE = 'GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE';
export const GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE_SUCCESS = `${GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE}/SUCCESS`;
export const GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE_FAILURE = `${GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE}/FAILURE`;

export const SET_IS_CONTACT_OVERRIDE_MODE = 'SET_IS_CONTACT_OVERRIDE_MODE';

export default {
  GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE,
  GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE_SUCCESS,
  GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE_FAILURE,
  SET_IS_CONTACT_OVERRIDE_MODE
};
